<template>
    <div class="article-cookies-necessary">
        <p>
            Necessary cookies enable core functionality and can only be disabled by changing your browser preferences.
        </p>
        <ul>
            <li>
                <strong>Cookie Consent</strong> - we use cookies to store your preferences in relation to the use of
                cookies more generally (cookies used for this purpose are: cookies_asked, cookies_video,
                cookies_analytic).
            </li>
            <li>
                <strong>Login System</strong> - we use cookies in relation to the login system of our website so that
                users can create and manage their account (cookies used for this purpose are: correlation, email, token,
                return).
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ArticleCookiesNecessary',
};
</script>
